import React from 'react';
import PropTypes from 'prop-types';
import { LazyLoadImage } from 'react-lazy-load-image-component';

import { slugify } from 'utils/string';

import { CheckListElem, CheckListRowElem, CheckImageWrap } from './ActivityChecklist.styles';

const ActivityChecklist = (props) => {
  const {
    checkListTitle,
    checkListItems,
    checklistImage: {
      title: imageName,
      xl: { url: imageUrl },
    },
  } = props;
  return (
    <CheckListRowElem className="u-block-margins relative">
      <CheckImageWrap>
        <LazyLoadImage
          className="block w-full h-full object-cover object-center rounded-base md:rounded-l-base md:rounded-r-none"
          src={imageUrl}
          alt={imageName}
        />
      </CheckImageWrap>
      <div className="container px-4 pt-4 mx-auto md:h-full">
        {checkListItems && (
          <div className="flex h-full -mx-4">
            <div className="flex-1 md:flex-1/2 flex flex-col justify-center h-full px-4">
              <h2 className="pb-4 md:pb-6 lg:pb-8">{checkListTitle}</h2>
              <ul className="flex flex-wrap -mx-2">
                {checkListItems.map((item) => (
                  <CheckListElem key={slugify(item)} className="inline-flex items-center list-none mb-3 w-1/2 px-2">
                    {item}
                  </CheckListElem>
                ))}
              </ul>
            </div>
          </div>
        )}
      </div>
    </CheckListRowElem>
  );
};

ActivityChecklist.defaultProps = {
  checkListItems: [],
  checklistImage: {
    xl: {
      url: '/assets/960x500.jpg',
    },
    title: 'placeholder image',
  },
};

ActivityChecklist.propTypes = {
  checkListTitle: PropTypes.string.isRequired,
  checkListItems: PropTypes.arrayOf(PropTypes.string),
  checklistImage: PropTypes.shape({
    title: PropTypes.string,
    xl: PropTypes.shape({
      url: PropTypes.string.isRequired,
    }),
  }),
};

export default ActivityChecklist;
